import React from "react";
import { PageNewState, MemoEditDialogInitialState } from ".";

export const MemoEditDialogContext = React.createContext({
  pageState: MemoEditDialogInitialState,
  setPageState: (pageState: PageNewState) => {},
});
